import type { BlockType } from '@next-space/fe-api-idl';
import { EXPORT_PAGE_TYPES } from './type';

export const isExportPageType = (type?: BlockType) => {
  if (type === undefined) return false;
  return EXPORT_PAGE_TYPES.includes(type);
};
